var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDoneGreenFill = function SvgIconDoneGreenFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 51.33c13.991 0 25.334-11.341 25.334-25.333C51.335 12.007 39.992.664 26 .664 12.011.664.668 12.006.668 25.997c0 13.992 11.342 25.334 25.333 25.334Z",
    fill: "#15C480"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.578 35.265 12.684-14.59a3 3 0 1 0-4.528-3.937L22.05 31.329a3 3 0 1 0 4.528 3.936Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.438 31.176-9.313-9.313a3 3 0 1 0-4.242 4.243l9.312 9.313a3 3 0 1 0 4.243-4.243Z"
  }))));
};
export default SvgIconDoneGreenFill;